<template>
  <div>
    <template v-for="(t, index) in splitText" :key="index">
      <a
        v-if="t.isLink"
        :href="t.text"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ t.displayText || t.text }}
      </a>
      <span
        v-else
        :class="{ 'opacity-80': !darker, 'opacity-100': fullOpacity }"
      >
        {{ t.text }}
      </span>
    </template>
  </div>
</template>

<script setup>
import { computed, toRef } from "vue";

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  darker: Boolean,
  fullOpacity: Boolean
});

const propText = toRef(props, "text");

// Match raw URLs or Markdown links [text](url)
const urlRegex = new RegExp(
  /(https?:\/\/[^\s\]]+)|(?:\[([^\]]+)\]\((https?:\/\/[^)]+)\))/gi
);

const splitText = computed(() => {
  const texts = [];
  let lastIndex = 0;
  let match;

  while ((match = urlRegex.exec(propText.value)) !== null) {
    if (match.index > lastIndex) {
      texts.push({
        isLink: false,
        text: propText.value.slice(lastIndex, match.index)
      });
    }

    if (match[2] && match[3]) {
      // Markdown-style [text](url)
      texts.push({ isLink: true, text: match[3], displayText: match[2] });
    } else {
      // Raw URL
      let text = match[0];
      const endsWithPeriod = text.endsWith(".");
      let endsWithParentheses = false;
      if (texts.length > 0) {
        if (texts[texts.length - 1].text.endsWith("(")) {
          endsWithParentheses = text.endsWith(")");
        }
      }
      if (endsWithPeriod || endsWithParentheses) {
        text = text.substring(0, text.length - 1);
      }
      texts.push({ isLink: true, text });
      if (endsWithPeriod) texts.push({ isLink: false, text: "." });
      if (endsWithParentheses) texts.push({ isLink: false, text: ")" });
    }

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < propText.value.length) {
    texts.push({ isLink: false, text: propText.value.slice(lastIndex) });
  }

  return texts;
});
</script>
